import * as types from './Reports.types';

const initialState = null;

const reports = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_REPORTS_LIST_SUCCESS: {
      if (action.reports.body) {
        return Object.assign({}, state, action.reports.body);
      } else {
        return Object.assign({}, state, action.reports);
      }
    }

    default:
      return state;
  }
};

export default reports;
